import { useMemo } from 'react';

import type { TemplateProductBreakdown } from 'src/modules/designStudio/components/DesignMenu/Menu/TemplateMenu/products/types';
import { TemplateProductCategories } from 'src/modules/designStudio/components/DesignMenu/Menu/TemplateMenu/products/types';
import { useRoofMaterialGroups } from 'src/modules/designStudio/components/DesignMenu/ProductCatalogMenu/RoofMenu/useRoofMaterialGroups';
import { useWallMaterialGroups } from 'src/modules/designStudio/components/DesignMenu/ProductCatalogMenu/WallMenu/useWallMaterialGroups';

export const useTemplateProductBreakdown = (): {
  breakdown: TemplateProductBreakdown;
  isEmpty: boolean;
} => {
  const wallGroups = useWallMaterialGroups();
  const roofGroups = useRoofMaterialGroups();

  return useMemo(() => {
    const breakdown = {
      [TemplateProductCategories.Walls]: wallGroups.filter(g => g.variation),
      [TemplateProductCategories.Roof]: roofGroups.filter(g => g.variation),
    };
    return {
      breakdown,
      isEmpty: breakdown.Roof.length !== 0 || breakdown.Walls.length !== 0,
    };
  }, [wallGroups, roofGroups]);
};
